import React from 'react';
import * as S from './BaseAppBar.styles';
const AppBar = ({
  className,
  leftContent,
  middleContent,
  rightContent,
  position = 'sticky'
}) => {
  return /*#__PURE__*/React.createElement(S.AppBar, {
    className: className,
    position: position
  }, /*#__PURE__*/React.createElement(S.Toolbar, {
    disableGutters: true
  }, /*#__PURE__*/React.createElement(S.ToolbarContent, null, /*#__PURE__*/React.createElement(S.ToolbarItem, {
    direction: "row",
    justifyContent: "flex-start",
    spacing: 2
  }, leftContent), middleContent && /*#__PURE__*/React.createElement(S.ToolbarItem, {
    direction: "row",
    justifyContent: "center",
    spacing: 2
  }, middleContent), /*#__PURE__*/React.createElement(S.ToolbarItem, {
    direction: "row",
    justifyContent: "flex-end",
    spacing: 2
  }, rightContent))));
};
export default AppBar;